/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The SectionCreateForm model module.
   * @module textbook/model/SectionCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>SectionCreateForm</code>.
   * @alias module:textbook/model/SectionCreateForm
   * @class
   * @param title {String} 标题
   * @param seenToc {Boolean} 在目录中是否可见
   * @param type {Integer} 0课时练习 1扩展阅读 2扩展视频 3课文录音 4AI情景对话 5考试
   * @param lessonId {Integer} Lession id
   * @param unitId {Integer} unit id
   * @param textbookId {Integer} textbook id
   */
  var exports = function(title, seenToc, type, lessonId, unitId, textbookId) {
    var _this = this;

    _this['title'] = title;
    _this['seenToc'] = seenToc;
    _this['type'] = type;


    _this['lessonId'] = lessonId;
    _this['unitId'] = unitId;
    _this['textbookId'] = textbookId;

  };

  /**
   * Constructs a <code>SectionCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/SectionCreateForm} obj Optional instance to populate.
   * @return {module:textbook/model/SectionCreateForm} The populated <code>SectionCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'seenToc')) {
        obj['seenToc'] = ApiClient.convertToType(data['seenToc'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'filePath')) {
        obj['filePath'] = ApiClient.convertToType(data['filePath'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'directions')) {
        obj['directions'] = ApiClient.convertToType(data['directions'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'lessonId')) {
        obj['lessonId'] = ApiClient.convertToType(data['lessonId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'unitId')) {
        obj['unitId'] = ApiClient.convertToType(data['unitId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textbookId')) {
        obj['textbookId'] = ApiClient.convertToType(data['textbookId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'targetPoint')) {
        obj['targetPoint'] = ApiClient.convertToType(data['targetPoint'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 标题
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 在目录中是否可见
   * @member {Boolean} seenToc
   */
  exports.prototype['seenToc'] = undefined;
  /**
   * 0课时练习 1扩展阅读 2扩展视频 3课文录音 4AI情景对话 5考试
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 文件路径
   * @member {String} filePath
   */
  exports.prototype['filePath'] = undefined;
  /**
   * 题目指令
   * @member {String} directions
   */
  exports.prototype['directions'] = undefined;
  /**
   * Lession id
   * @member {Integer} lessonId
   */
  exports.prototype['lessonId'] = undefined;
  /**
   * unit id
   * @member {Integer} unitId
   */
  exports.prototype['unitId'] = undefined;
  /**
   * textbook id
   * @member {Integer} textbookId
   */
  exports.prototype['textbookId'] = undefined;
  /**
   * 课程总积分
   * @member {Integer} targetPoint
   */
  exports.prototype['targetPoint'] = undefined;



  export default exports;
;


